import mergeConfig from 'coact/config/mergeConfig'

import Page from './Page/index.js'

const config = {
  routes: {
    stockScanner: {
      title: '商品庫存價格查詢(手機)',
      path: '/route/stockScanner',
      component: Page,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
